/**
 * AiGenerateButton — the Sparkles entry into the wizard, mounted in the
 * library panel and the drawer's package picker.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useState, type FC } from 'react';
import { Sparkles } from 'lucide-react';
import type { FlowOptimizerLibraryProvider } from '@trafficpulse/shared';

import { Button } from '@/components/ui';

import type { AssembledLibraryPayload } from '../validate/assemble-accepted';
import AiGenerateWizard from './AiGenerateWizard';

export interface AiGenerateButtonProps {
  provider: FlowOptimizerLibraryProvider;
  campaignId: string;
  campaignLocked?: boolean;
  draftApply?: (assembled: AssembledLibraryPayload) => void;
  className?: string;
}

const AiGenerateButton: FC<AiGenerateButtonProps> = ({
  provider,
  campaignId,
  campaignLocked,
  draftApply,
  className,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={className ?? 'h-7 px-2.5 text-xs'}
        onClick={() => setOpen(true)}
      >
        <Sparkles className="mr-1 h-3.5 w-3.5 text-primary" aria-hidden />
        Generate with AI
      </Button>
      {open ? (
        <AiGenerateWizard
          open
          onClose={() => setOpen(false)}
          provider={provider}
          campaignId={campaignId}
          campaignLocked={campaignLocked}
          draftApply={draftApply}
        />
      ) : null}
    </>
  );
};

export default AiGenerateButton;
